module.exports = __webpack_public_path__ + "img/hq_qrcode.f644d6c8.jpg";